import { Component } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import { NavigationService } from '../../../services/navigation.service'

@Component({
  standalone: true,
  selector: 'customer-portal-app-navbar-back',
  templateUrl: './navbar-back.component.html',
  imports: [MatButton, MatIcon]
})
export class NavbarBackComponent {
  backClicked = false
  constructor (
    public readonly navigationService: NavigationService
  ) {}

  backIsDisabled (): boolean {
    return !this.navigationService.hasBack() || this.backClicked === true
  }

  onClickB (): void {
    if (!this.backClicked) {
      this.backClicked = true
      setTimeout(() => {
        this.backClicked = false
      }, 200)
      this.navigationService.back()
    }
  }
}
